<template>
  <div class="container">
    <h1 class="py-4">加盟店マスタデータ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="l-pid">企業ID</label><br />
          <input v-model="companyId" placeholder="企業ID" class="input-boot" />
        </div>
        <div class="form-group col-md-6">
          <label for="l-pid">企業名</label><br />
          <input
            v-model="companyName"
            placeholder="企業名"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="l-pid">店舗ID</label><br />
          <input v-model="storeId" placeholder="店舗ID" class="input-boot" />
        </div>
        <div class="form-group col-md-6">
          <label for="l-pid">店舗名</label><br />
          <input v-model="storeName" placeholder="店舗名" class="input-boot" />
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #cell(企業ID)="data">
            <router-link
              :to="{
                name: 'MerchantDetails',
                query: { storeId: data.item.店舗ID },
              }"
              target="_blank"
              >{{ data.item.企業ID }}</router-link
            >
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "Merchant",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      companyId: "",
      companyName: "",
      storeId: "",
      storeName: "",
      key: 0,
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    this.labels = this.tsvFormat.bankitInfo.labels;
    this.loadCollection();
  },
  methods: {
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    clear() {
      this.companyId = "";
      this.companyName = "";
      this.storeId = "";
      this.storeName = "";
      this.loadCollection();
    },
    search() {
      let searchParams = {
        company_id: this.companyId,
        company_name: this.companyName,
        store_id: this.storeId,
        store_name: this.storeName,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      this.loading = true;

      let query = this.db.collection("merchants");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
      }
      // query.orderBy("contract_number", "asc");
      this.fileName = this.tsvFormat.merchantData.fileName;
      this.csvCurrentFields = this.tsvFormat.merchantData.labels;
      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              this.tableData.push({
                企業ID: data.company_id,
                企業名: data.company_name,
                店舗ID: data.store_id,
                店舗名: data.store_name,
              });
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
